
const digest = '4a5880440224575b6859f3d1637af20f7fc353621b5415a759ff0aa6629654e8';
const classes = {"wrapper":"_wrapper_j59dn_1","title":"_title_j59dn_5"};
const css = `._wrapper_j59dn_1 {
  display: flex;
  flex-direction: column;
}
._wrapper_j59dn_1 ._title_j59dn_5 {
  font-family: Poppins, sans-serif;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  